import { render, staticRenderFns } from "./StcdR.vue?vue&type=template&id=3f47db6f"
import script from "./StcdR.vue?vue&type=script&lang=js"
export * from "./StcdR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports